import { render, staticRenderFns } from "./DrawingArea.vue?vue&type=template&id=63e021bc&scoped=true&lang=pug&"
import script from "./DrawingArea.vue?vue&type=script&lang=ts&"
export * from "./DrawingArea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e021bc",
  null
  
)

export default component.exports